import type { PolymorphicComponent } from '@hh.ru/magritte-types';
import { BaseText } from '@hh.ru/magritte-ui-typography/BaseText';
import type { TextProps } from '@hh.ru/magritte-ui-typography/types';

export const Text: PolymorphicComponent<React.PropsWithChildren<TextProps>, 'div'> = ({
    Element = 'div',
    style = 'primary',
    typography = 'paragraph-2-regular',
    ...restProps
}) => {
    return <BaseText Element={Element} style={style} typography={typography} {...restProps} />;
};
